<template>
  <div class="main">
    <LoadingSpinner v-if="loading" message="Gruppen werden geladen..."/>
    <BackButton v-if="pool"/>
    <h1 v-if="pool">Gruppeninfos</h1>
    <div class="joined-banner" v-if="pool && $route.query.joined">
      ✓ Du bist der Gruppe <b>{{pool.name}}</b> erfolgreich beigetreten!
    </div>
    <div class="pool-infos" v-if="pool">
      <img v-if="pool && pool.image_url" :src="pool.image_url" class="pool-image">
      <h2>{{pool.name}}</h2>
      <p>Erstellt am <b>{{pool.created_at}}</b></p>
      <p><b>{{pool.members_joined}}</b> Beigetretene Nutzer · <b>{{pool.members_profile}}</b> mit Profil</p>
      <p>{{ pool.description }}</p>
      <p class="invite-link" @click="copyInviteCode(pool.code)">
        Einladungscode: <b>{{pool.code}}</b>
        <span v-for="notification in notifications" :key="notification.id" class="copy-notification">
          Kopiert!
        </span>
      </p>
      <QRCodeVue :value="pool.code" style="align-self: center; margin-top: 20px; display: none;"/>
      <button class="danger single" @click="leaving_pool = true" v-if="!leaving_pool">Gruppe verlassen</button>
      <div v-if="leaving_pool" class="leaving-pool">
        <p>Sicher, dass du die Gruppe verlassen willst?</p>
        <div class="buttons">
          <button @click="leaving_pool = false">Abbrechen</button>
          <button class="danger" @click="leavePool()">Verlassen</button>
        </div>
      </div>
    </div>
    <div class="enter-group" v-if="creating_pool">
      <button class="back_button" @click="setup()"><img src="@/assets/images/back.svg">Zurück</button>
      <h2>Erstelle jetzt deine Gruppe</h2>
      <form v-on:submit.prevent="createPool">
        <div class="form-item">
          <label for="new_group_name">Gruppenname</label>
          <input type="text" id="new_group_name" v-model="newGroupName">
        </div>
        <div class="form-item center">
          <button type="submit">Erstellen</button>
        </div>
      </form>
    </div>
    <div class="enter-group" v-if="joining_pool">
      <button class="back_button" @click="setup()"><img src="@/assets/images/back.svg">Zurück</button>
      <h2>Tritt einer Gruppe bei</h2>
      <form v-on:submit.prevent="joinPool">
        <div class="form-item">
          <label for="new_group_name">Einladungs-Code</label>
          <input type="text" id="new_group_name" v-model="inviteCode">
        </div>
        <div class="form-item center">
          <p v-if="error">{{ error }}</p>
          <button type="submit">Beitreten</button>
        </div>
      </form>
    </div>
    <h1 v-if="available_pools && !creating_pool && !joining_pool">Deine Gruppen</h1>
    <div class="available-pools" v-if="available_pools && available_pools.length > 0 && !creating_pool && !joining_pool">
      <div class="pool-infos list" v-for="pool in available_pools" :key="pool.pool_id">
        <div class="pool-infos no-padding">
          <h2>{{pool.name}}</h2>
          <p>Erstellt am <b>{{pool.created_at}}</b></p>
          <p><b>{{pool.members}}</b> Mitglieder</p>
        </div>
        <router-link :to="'/pool-settings?pool=' + pool.pool_id">Details</router-link>
      </div>
      <div class="add-pool-wrapper">
        <button class="add_pool" @click="joining_pool = true"><img src="@/assets/images/group_add.svg"><h3>Gruppe beitreten</h3></button>
      </div>
      <div class="add-pool-wrapper" v-if="isAdmin || 1 == 1">
        <button class="add_pool" @click="creating_pool = true"><img src="@/assets/images/group_add.svg"><h3>Neue Gruppe</h3></button>
      </div>
    </div>
    <div class="no-pools-notification" v-if="available_pools && available_pools.length === 0">
      <h2>Noch keine Gruppen vorhanden</h2>
    </div>
  </div>
</template>

<script>
import AuthService from '@/services/AuthService.js';
import moment from 'moment';
import BackButton from "@/components/BackButton.vue";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import QRCodeVue from 'qrcode.vue';
export default {
  "name": "PoolSettingsView",
  components: {LoadingSpinner, BackButton, QRCodeVue},
  data() {
    return {
      isAdmin: false,
      loading: true,
      pool: null,
      creating_pool: false,
      inviteCode: null,
      joining_pool: false,
      leaving_pool: false,
      newGroupName: null,
      available_pools: null,
      error: null,
      notifications: []
    }
  },
  watch:{
    $route (){
      this.setup();
    }
  },
  methods: {
    logout() {
      this.$store.dispatch('logout');
      this.$router.push('/login');
    },
    async copyInviteCode(code) {
      if (!code) return;
      try {
        if (navigator.clipboard && window.isSecureContext) {
          await navigator.clipboard.writeText(code);
        } else {
          const textArea = document.createElement("textarea");
          textArea.value = code;
          textArea.style.position = "fixed";
          textArea.style.left = "-999999px";
          textArea.style.top = "-999999px";
          document.body.appendChild(textArea);
          textArea.focus();
          textArea.select();
          document.execCommand('copy');
          textArea.remove();
        }
        
        const id = Date.now() + Math.random();
        this.notifications.push({ id });
        setTimeout(() => {
          this.notifications = this.notifications.filter(n => n.id !== id);
        }, 1200);
      } catch (err) {
        console.error('Failed to copy: ', err);
      }
    },
    async setup() {
      this.available_pools = null;
      this.pool = null;
      this.creating_pool = false;
      this.joining_pool = false;

      try {
        this.msg = await AuthService.getUser()
        this.isAdmin = !!this.msg.msg[0].isAdmin;
      } catch(e){
        console.error(e)
      }


      if(this.$route.query.pool){
        await this.getPoolData(this.$route.query.pool)
      } else {
        this.msg = await AuthService.getUserJoinedPools()
        if(this.msg.success) {
          this.available_pools = this.msg.msg.map(pool => {return {...pool, created_at: moment(pool.created_at).format("DD.MM.YYYY")}})
        }
        this.loading = false;
      }
    },
    async createPool() {
      this.msg = await AuthService.createPool({"new_group_name": this.newGroupName});
      if (this.msg.success) {
        this.$router.push('/pool-settings?pool=' + this.msg.newPoolId)
      } else {
        this.msg = this.msg.msg
      }
    },
    async joinPool() {
      this.msg = await AuthService.joinPool({"invite_code": this.inviteCode.toUpperCase()});
      if (this.msg.success) {
        try {
          AuthService.updateSelectedPool({selected_pool: this.msg.newPoolId})
          this.$store.dispatch('updateLastSelectedPool', {pool_id: this.msg.newPoolId})
        } catch(e) {
          console.error(e)
        }

        // if the user has no profile in this pool yet, send them straight to profile creation
        // instead of the group detail page, so it's immediately obvious what to do next
        try {
          let profileCheck = await AuthService.getUserProfileFromPool({pool_id: this.msg.newPoolId})
          if (profileCheck.success && profileCheck.msg.length === 0) {
            this.$router.push('/account?create=1&joined=1&pool=' + this.msg.newPoolId)
            return
          }
        } catch (e) {
          console.error(e)
        }
        this.$router.push('/pool-settings?pool=' + this.msg.newPoolId + '&joined=1')
      } else {
        this.error = this.msg.msg
      }
    },
    async leavePool() {
      this.msg = await AuthService.leavePool({"pool_id": this.$route.query.pool});
      if (this.msg.success) {
        this.$router.push('/pool-settings')
      } else {
        this.msg = this.msg.msg
      }

      this.leaving_pool = false;
    },
    async getPoolData(id){
      let msg = await AuthService.getPool({pool_id: id});
      if(msg.success){
        this.pool = {...msg.msg, created_at: moment(msg.msg.created_at).format("DD.MM.YYYY")}
        this.loadImage(id)
      }
      this.loading = false;
     },
     async loadImage(pool_id) {
      try {
        let result = await AuthService.getPoolImage({ pool_id: pool_id });
        if (!result.success) return false;

        try {
          const img = await AuthService.getImage({ image_id: result.msg.image_id });
          this.pool = {...this.pool, image_url: URL.createObjectURL(img)}
        } catch (error) {
          if (error.response && error.response.status === 404) {
            console.warn(`Bild mit ID ${result.image_id} nicht gefunden (404).`);
            return null; // Optional: Fallback-Bild-URL hier zurückgeben
          } else {
            console.error(`Fehler beim Laden des Bildes ${result.image_id}:`, error);
            return null;
          }
        }
      } catch(e) {
          console.error(e)
          return false
      }
    },
    },
    async beforeCreate() {
      if (!this.$store.getters.isLoggedIn) {
        this.$router.push('/login');
      }
    },
    async mounted() {
      await this.setup()
    }
}
</script>
<style scoped>
.main {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  height: 100%;
  padding: 20px;
  box-sizing: border-box;
}

h1 {
  font-size: 2rem;
  font-weight: 800;
  letter-spacing: -0.02em;
  margin: 24px 0;
  color: white;
  margin-left: 10px;
  width: 100%;
  text-align: left;
  max-width: var(--max-width);
}

h2 {
  font-size: 1.4rem;
  font-weight: 700;
  margin-bottom: 4px;
  margin-top: 10px;
}

.joined-banner {
  width: 100%;
  max-width: var(--mid-width);
  background: #E8F5E9;
  color: #2E7D32;
  font-weight: 700;
  padding: 14px 18px;
  border-radius: var(--radius-m);
  margin-bottom: 16px;
  text-align: center;
  box-sizing: border-box;
}

/* Group Info Card */
.pool-infos {
  width: 100%;
  max-width: var(--mid-width);  
  border-radius: var(--radius-l);
  background: white;
  padding: 12px;
  text-align: left;
  display: flex;
  flex-direction: column;
}

.pool-image {
  width: 100%;
  height: 200px;
  object-fit: cover;
  border-radius: var(--radius-m);
  margin-bottom: 20px;
}

.pool-infos p {
  margin: 2px 0;
  font-size: 0.95rem;
}

.invite-link {
  background: #F5F5F7;
  padding: 16px;
  border-radius: var(--radius-m);
  margin-top: 24px !important;
  margin-bottom: 10px !important;
  text-align: center;
  font-weight: 700;
  font-size: 1.1rem;
  color: var(--primary-color);
  border: 1px dashed var(--primary-color);
  cursor: pointer;
  position: relative;
  user-select: none;
  transition: background-color 0.2s, transform 0.1s;
}

.invite-link:active {
  transform: scale(0.98);
  background-color: #eef2f6;
}

.copy-notification {
  position: absolute;
  left: 50%;
  top: -24px;
  transform: translateX(-50%);
  background: var(--primary-color);
  color: white;
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 0.85rem;
  font-weight: 600;
  box-shadow: var(--shadow-soft, 0 4px 10px rgba(0, 0, 0, 0.15));
  pointer-events: none;
  animation: fly-up-fade-out 1.2s ease-out forwards;
  white-space: nowrap;
}

@keyframes fly-up-fade-out {
  0% {
    opacity: 0;
    transform: translate(-50%, 0) scale(0.9);
  }
  15% {
    opacity: 1;
    transform: translate(-50%, -10px) scale(1);
  }
  100% {
    opacity: 0;
    transform: translate(-50%, -40px) scale(0.95);
  }
}

/* Pool List */
.available-pools {
  width: 100%;
  max-width: var(--max-width);
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding-bottom: 40px;
}

.pool-infos.list {
  padding: 20px 14px;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  background: white;
  border-radius: var(--radius-l);
  box-shadow: var(--shadow-soft);
}

.pool-infos.no-padding {
  padding: 0 !important;
}

.pool-infos.list h2 {
  margin: 0;
  font-size: 1.2rem;
}

.pool-infos.list a {
  background: var(--primary-color);
  color: white;
  text-decoration: none;
  padding: 8px 16px;
  border-radius: var(--radius-m);
  font-weight: 600;
  font-size: 0.9rem;
}

/* Buttons & Forms */
button {
  width: 100%;
  padding: 16px;
  border-radius: var(--radius-m);
  font-weight: 700;
  border: none;
  font-family: var(--font);
  cursor: pointer;
  transition: all 0.2s ease;
}

button.add_pool {
  background: white;
  color: var(--text-main);
  border: 1px solid var(--border-color);
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 12px;
  box-shadow: var(--shadow-soft);
}

button.add_pool img {
  width: 24px;
  filter: none;
}

button.add_pool h3 {
  margin: 0;
  font-size: 1rem;
}

button.danger {
  background: #FFF0F0;
  color: #FF3B30;
}

.enter-group {
  width: 100%;
  max-width: 400px;
  background: white;
  padding: 32px;
  border-radius: var(--radius-xl);
  box-shadow: var(--shadow-strong);
}

.form-item {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 20px;
  text-align: left;
}

input {
  width: 100%;
  background: #F5F5F7;
  border: 1px solid transparent;
  padding: 14px 18px;
  border-radius: var(--radius-m);
  font-family: var(--font);
  font-size: 1rem;
  outline: none;
}

input:focus {
  background: white;
  border-color: var(--primary-color);
}

.back_button {
  background: none;
  color: var(--primary-color);
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 0;
  margin-bottom: 20px;
  width: fit-content;
}

.back_button img {
  width: 16px;
  filter: invert(34%) sepia(87%) saturate(5451%) hue-rotate(200deg) brightness(101%) contrast(105%);
}

.no-pools-notification {
  margin-top: 60px;
  color: var(--text-secondary);
}
</style>
